import React from 'react';
import styles from './Checkbox.module.css';

interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
    label: string;
}

// 체크박스 컴포넌트
const Checkbox: React.FC<CheckboxProps> = ({label, className, ...props}) => {
    return (
        <label className={`${styles.container} ${className || ''}`}>
            <input type="checkbox" className={styles.input} {...props} />
            <span className={styles.checkmark}></span>
            <span className={styles.label}>{label}</span>
        </label>
    );
};

export default Checkbox;